<template>
  <div class="case-content">
    <div class="intro-tekst">
        <slot name="intro-tekst"></slot>
      </div>
      <div class="outro-img">
        <slot name="case-img"></slot>
      </div>
       <div class="outro-tekst">
        <slot name="outro-tekst"></slot>
      </div>
  </div>
</template>

<script>

export default {
  name: 'endCase',
}
</script>

<style lang="scss" scoped>

.intro-tekst{
  h2{
    text-align: center;
  }
  p{
    max-width: 680px;
    margin: 0 auto;
    display: block;
    text-align: center;
  }
}
.outro-img{
  img{
    display: block;
    margin: 0 auto;
    margin-top: layout-val-8(4);
    margin-bottom: layout-val-8(4);
    max-width:270px;
  }
}
.outro-tekst{
  h4{
    text-align: center;   
    margin-top: layout-val-8(12);
    padding-bottom: layout-val-8(4);
  }
}

</style>